/**
 * Service to fetch intervention/inattentiveness data for students
 */
import { getApiUrl } from './apiConfig';

/**
 * Fetch intervention count for a student by user_id
 * @param {string} userId - The student's user_id
 * @returns {Promise<number>} The count of interventions
 */
export const getInterventionCount = async (userId) => {
  try {
    if (!userId) {
      console.warn('⚠️ No user_id provided for intervention count');
      return 0;
    }

    console.log('🔍 Fetching intervention count for user_id:', userId);
    
    // The backend-api service runs on port 4042
    // For local development, route directly to backend-api service
    let apiUrl;
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost' && window.location.port === '3000') {
      apiUrl = `http://localhost:4042/api/v1/inattentiveness?user_id=${userId}`;
    } else {
      // Production: use relative URL (will be proxied by nginx)
      apiUrl = `/api/v1/inattentiveness?user_id=${userId}`;
    }

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        console.log('📊 No interventions found for user_id:', userId);
        return 0;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ Intervention data fetched:', data);
    
    return data.count || 0;
  } catch (error) {
    console.error('❌ Error fetching intervention count:', error);
    return 0; // Return 0 on error to avoid breaking the UI
  }
};

/**
 * Fetch all intervention events for a student by user_id
 * @param {string} userId - The student's user_id
 * @returns {Promise<Array>} Array of intervention events
 */
export const getInterventions = async (userId) => {
  try {
    if (!userId) {
      console.warn('⚠️ No user_id provided for interventions');
      return [];
    }

    console.log('🔍 Fetching interventions for user_id:', userId);
    
    // The backend-api service runs on port 4042
    // For local development, route directly to backend-api service
    let apiUrl;
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost' && window.location.port === '3000') {
      apiUrl = `http://localhost:4042/api/v1/inattentiveness?user_id=${userId}`;
    } else {
      // Production: use relative URL (will be proxied by nginx)
      apiUrl = `/api/v1/inattentiveness?user_id=${userId}`;
    }

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        console.log('📊 No interventions found for user_id:', userId);
        return [];
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ Interventions fetched:', data);
    
    return data.events || [];
  } catch (error) {
    console.error('❌ Error fetching interventions:', error);
    return []; // Return empty array on error
  }
};
